import script from "./GMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./GMenu.vue?vue&type=script&setup=true&lang=js"

import "./GMenu.vue?vue&type=style&index=0&id=4af16bb8&scoped=true&lang=css"

import exportComponent from "D:\\Project\\contest2022\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4af16bb8"]])

export default __exports__
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QMenu,QCard,QCardSection,QCardActions,QSpace,QBtn});
